import { render, staticRenderFns } from "./MessageDisplay.vue?vue&type=template&id=df874d26&lang=pug&"
import script from "./MessageDisplay.ts?vue&type=script&lang=js&"
export * from "./MessageDisplay.ts?vue&type=script&lang=js&"
import style0 from "./MessageDisplay.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports